import { render } from "./affiliates-base.view.vue?vue&type=template&id=baa6a88e&scoped=true&ts=true"
import script from "./affiliates-base.view.vue?vue&type=script&lang=ts"
export * from "./affiliates-base.view.vue?vue&type=script&lang=ts"

import "./affiliates-base.view.vue?vue&type=style&index=0&id=baa6a88e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa6a88e"]])

export default __exports__